module.exports = __webpack_public_path__ + "img/jgzx.396d5058.png";